module.exports = __webpack_public_path__ + "static/img/quan.e945091.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quan.png
// module id = 943m
// module chunks = 1